__webpack_require__.p = "/mobil/static/";